// this component should ONLY be used for order.isAfterHoursOrder
import _ from 'lodash';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import useStores from 'shared/hooks/use-stores';
import { CheckoutAccordion } from 'shared/components';
import { getAfterHoursWindow, formatAfterHoursEstimate } from 'shared/helpers/order-estimates';
import {
  CheckoutLabelGrouping,
  CheckoutLabel,
  CheckoutBody,
  CheckoutSectionHeading,
} from 'checkout/components/styles/common';

function Time() {
  const { Cart } = useStores();
  if (!Cart.isAfterHoursOrder) {
    return null;
  }
  const serviceType = _.get(Cart, 'order.deliveryOption', 'pickup');
  const estimate = _.upperFirst(formatAfterHoursEstimate(getAfterHoursWindow(Cart.openInfo, serviceType)));

  return (
    <CheckoutLabelGrouping>
      <CheckoutLabel card>
        <CheckoutSectionHeading>Time</CheckoutSectionHeading>
      </CheckoutLabel>

      <CheckoutBody>
        <CheckoutAccordion dataCyName='time'>
          <Container>
            <img src='/icons/clock.svg' alt='' width='16px' />
            <TextContainer>
              <div>
                <strong>We're closed now but you can still order!</strong>
              </div>
              <SubText>Order can be picked up: {estimate}</SubText>
            </TextContainer>
          </Container>
        </CheckoutAccordion>
      </CheckoutBody>
    </CheckoutLabelGrouping>
  );
}

export default observer(Time);

const Container = styled.div`
  padding: 21px 21px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`;

const TextContainer = styled.div`
  margin-left: 10px;
  font-size: 14px;
  color: #5d666d;
`;

const SubText = styled.div`
  font-size: 13px;
  margin-top: 10px;
`;
